// import Request from 'core/gd/data/request'
import Request from '../../../../src/core/gd/data/request'

export default class ApiNotifications {

    // deprecated
    getUpdates() {
        return new Request(this, 'GET', 'notifications-new')
    }

    // new
    static selectAllNotifications() {
        return new Request(this, 'GET', 'notifications-new')
    }

    deleteUpdates(ids:ID[]) {
        return new Request(this,'PUT','updates',{ids})
    }
}
